export default [
  {
    key: 'code',
    label: '件名番号',
    style: {
    }
  }, 
  {
    key: 'branchOfficeName',
    label: '支店',
    style: {
    }
  }, 
  {
    key: 'customerName',
    label: '客先',
    style: {
    }
  },  
  {
    key: 'constructionName',
    label: '工事種別',
    style: {
    }
  }, 
  {
    key: 'name',
    label: '件名名称',
    style: {
    }
  }, 
  {
    key: 'actions',
    label: '',
    style: {
    }
  },
];


// WEBPACK FOOTER //
// ./src/containers/master/kenmei/listHeader.js